import React from "react";
import { Box, Dialog, DialogContent, IconButton, Typography, alpha } from "@mui/material";
import { Close as CloseIcon, LocalOffer } from "@mui/icons-material";
import OfferCarousel from "./OfferCarousel";
import { LUXURY } from "data/guestLuxuryTheme";

const OffersDialog = ({
    luxury = false,
    open,
    onClose,
    isMobile,
    offerItems,
    onAddToCart,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            fullScreen={isMobile}
            PaperProps={{
                sx: {
                    borderRadius: isMobile ? 0 : 4,
                    overflow: "hidden",
                    bgcolor: luxury ? LUXURY.page : "#f4f6fb",
                    border: isMobile ? "none" : `1px solid ${alpha("#ffffff", 0.4)}`,
                    boxShadow: isMobile ? "none" : "0 30px 70px rgba(15,23,42,0.28)",
                },
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    px: { xs: 2, md: 3 },
                    py: { xs: 2.2, md: 2.6 },
                    background: luxury
                        ? LUXURY.barGradient
                        : "radial-gradient(circle at 15% 18%, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0) 45%), radial-gradient(circle at 85% 22%, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 38%), linear-gradient(120deg, #f59e0b 0%, #ea580c 55%, #dc2626 100%)",
                    color: "#fff",
                    overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        right: -36,
                        bottom: -42,
                        width: 150,
                        height: 150,
                        borderRadius: "50%",
                        bgcolor: alpha("#ffffff", 0.14),
                        filter: "blur(1px)",
                    }}
                />

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        gap: 1.5,
                        position: "relative",
                    }}
                >
                    <Box>
                        <Box
                            sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 0.75,
                                px: 1.1,
                                py: 0.45,
                                borderRadius: 99,
                                bgcolor: alpha("#ffffff", 0.18),
                                border: `1px solid ${alpha("#ffffff", 0.28)}`,
                                mb: 1,
                                backdropFilter: "blur(6px)",
                            }}
                        >
                            <LocalOffer sx={{ fontSize: 14 }} />
                            <Typography sx={{ fontSize: "0.68rem", fontWeight: 800, letterSpacing: 0.7 }}>
                                LIMITED-TIME DEALS
                            </Typography>
                        </Box>
                        <Typography sx={{ fontSize: { xs: "1.1rem", md: "1.35rem" }, fontWeight: 900, lineHeight: 1.15 }}>
                            Hot Deals &amp; Offers
                        </Typography>
                        <Typography sx={{ fontSize: "0.8rem", mt: 0.5, color: alpha("#ffffff", 0.92), maxWidth: 420 }}>
                            Handpicked combos and discount plates curated for faster, smarter ordering.
                        </Typography>
                    </Box>

                    <IconButton
                        onClick={onClose}
                        sx={{
                            color: "#fff",
                            bgcolor: alpha("#ffffff", 0.16),
                            border: `1px solid ${alpha("#ffffff", 0.28)}`,
                            backdropFilter: "blur(6px)",
                            "&:hover": { bgcolor: alpha("#ffffff", 0.26) },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Box sx={{ display: "flex", gap: 1, mt: 1.6, position: "relative", flexWrap: "wrap" }}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.8,
                            px: 1.2,
                            py: 0.7,
                            borderRadius: 2,
                            bgcolor: alpha("#ffffff", 0.16),
                            border: `1px solid ${alpha("#ffffff", 0.26)}`,
                            backdropFilter: "blur(4px)",
                        }}
                    >
                        <Typography sx={{ fontSize: "0.95rem", fontWeight: 900, lineHeight: 1 }}>
                            {offerItems.length}
                        </Typography>
                        <Typography sx={{ fontSize: "0.72rem", color: alpha("#ffffff", 0.9) }}>
                            active offer{offerItems.length !== 1 ? "s" : ""}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            px: 1.2,
                            py: 0.7,
                            borderRadius: 2,
                            bgcolor: alpha("#ffffff", 0.16),
                            border: `1px solid ${alpha("#ffffff", 0.26)}`,
                            backdropFilter: "blur(4px)",
                        }}
                    >
                        <Typography sx={{ fontSize: "0.72rem", color: alpha("#ffffff", 0.9) }}>
                            Swipe through and tap any deal to add instantly
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <DialogContent
                sx={{
                    p: { xs: 1.5, md: 2.5 },
                    background: "linear-gradient(180deg, #f4f6fb 0%, #eef2f9 100%)",
                }}
            >
                <Box
                    sx={{
                        borderRadius: { xs: 2.2, md: 2.8 },
                        bgcolor: "#ffffff",
                        border: `1px solid ${alpha("#d7deef", 0.7)}`,
                        boxShadow: "0 16px 34px rgba(15,23,42,0.08)",
                        px: { xs: 1.1, md: 1.5 },
                        py: { xs: 1.2, md: 1.5 },
                    }}
                >
                    <OfferCarousel
                        offers={offerItems}
                        onAddToCart={onAddToCart}
                        hideHeader
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default OffersDialog;
